<div class="container">
  <button
    type="button"
    mat-icon-button
    class="close-button"
    [mat-dialog-close]="false"
    fxFlexAlign="end"
    aria-label="Close"
  >
    <mat-icon class="md-24">close</mat-icon>
  </button>
  <div fxLayout="column" fxLayoutAlign="center center">
    <h3>Your browser is not compatible with lineup.</h3>
    <p class="main-text">
      You are using a web browser not supported by this website. Some functionality may not work as intended. Use or
      upgrade/install the latest version of Chrome, Firefox or Edge to take full advantage of the site.
    </p>
    <div fxLayout="row" fxLayout.xs="column" class="logo-link-container">
      <div fxLayout="column" fxLayoutAlign="center center">
        <img class="browser-logo" src="../assets/img/chrome_200.png" />
        <a mat-button color="primary" target="_blank" href="https://www.google.com/chrome/">Download Chrome</a>
      </div>
      <div fxLayout="column" fxLayoutAlign="center center" class="logo-link-container">
        <img class="browser-logo" src="../assets/img/firefox_200.png" />
        <a mat-button color="primary" target="_blank" href="https://www.mozilla.org/en-US/firefox/">Download Firefox</a>
      </div>
      <div fxLayout="column" fxLayoutAlign="center center" class="logo-link-container">
        <img class="browser-logo" src="../assets/img/edge_200.png" />
        <a mat-button color="primary" target="_blank" href="https://www.microsoft.com/en-us/edge/">Download Edge</a>
      </div>
    </div>
  </div>
</div>
